import React from 'react';
import './common-button.scss';
import { TouchableOpacity } from '../../common';
import { SpinnerLoader } from '../spinner';
import { isString } from 'lodash';

interface CommonButtonProps {
  text: string;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
  buttonStyle?: string;
  spinnerStyle?: string;
  style?: React.CSSProperties;
  textStyle?: string;
  spinnerColor?: string;
  startIcon?: string | JSX.Element;
  endIcon?: string | JSX.Element;
  spinnerSize?: number;
}

export const CommonButton: React.FC<CommonButtonProps> = ({
  text,
  onPress,
  disabled = false,
  loading = false,
  buttonStyle = '',
  style = {},
  spinnerStyle = '',
  textStyle = '',
  spinnerColor = '',
  startIcon,
  endIcon,
  spinnerSize = 24,
}) => {
  return (
    <TouchableOpacity
      className={`button-view-component primary-bg ${buttonStyle}`}
      onPress={onPress}
      disabled={disabled || loading}
      style={style}
    >
      {loading ? (
        <SpinnerLoader
          className={`button-component-item-view ${spinnerStyle}`}
          color={spinnerColor}
          size={spinnerSize}
        />
      ) : (
        <div className="button-component-item-view">
          {isString(startIcon) ? <img src={startIcon} alt="" /> : startIcon}
          <span
            className={`button-view-component-text font-semibold ${textStyle}`}
          >
            {text}
          </span>
          {isString(endIcon) ? <img src={endIcon} alt="" /> : endIcon}
        </div>
      )}
    </TouchableOpacity>
  );
};
